import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_BOOKING_DETAILS, GET_BOOKING_DETAILS_ERROR, GET_BOOKING_DETAILS_SUCCESS } from '../../../actions.js';

function* getBookingDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/booking-detail`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetBookingDetails() {
  yield takeEvery(GET_BOOKING_DETAILS, getBookingDetails);
}

function* getBookingDetailsSaga() {
  yield all([fork(watchGetBookingDetails)]);
}

export default getBookingDetailsSaga;
